import { get } from 'lodash';
import { UserSettingsEnum } from 'Common/UserSettings/helpers/helper';
import * as CommonStateSelectors from 'State/selectors';

const root = state => get(state, 'UserSettingsState');

export const getUseStudentAddressSetting = (state, formName, defaultValue) => {
  return get(
    root(state)[CommonStateSelectors.getUserName(state)],
    UserSettingsEnum.LettersUseStudentAddress + formName,
    defaultValue
  );
};



// WEBPACK FOOTER //
// ./src/common/Components/UseStudentAddressButtonGroup/Selectors.js